export default __webpack_public_path__ + "static/cubes.8c2fd5ebefd148351b17208bcdd703a6.png";